import React, { useContext } from 'react';
import { SettingsContext } from "../../context/SettingsContext.js";
import { isFilteredOptionItem } from "../../functions/isFilteredOptionItem.js";
import { DefaultOptionWrapper } from "../DefaultOptionWrapper/DefaultOptionWrapper.js";
import { ItemButton } from "../ItemButton/ItemButton.js";
import { ItemLabel } from "../ItemLabel/ItemLabel.js";
import styles from "./ItemOption.module.js";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function ItemOption({
  item,
  selected,
  previousFolderLabel,
  buttonProps = {}
}) {
  const {
    optionWrapper: OptionWrapper = DefaultOptionWrapper
  } = useContext(SettingsContext);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isFilteredOptionItem(item) && item.folderLabel !== previousFolderLabel && item.folderLabel && /*#__PURE__*/_jsx("strong", {
      className: styles.folderLabel,
      children: item.folderLabel
    }), /*#__PURE__*/_jsx(ItemButton, {
      ...buttonProps,
      children: /*#__PURE__*/_jsxs(OptionWrapper, {
        option: item,
        inFocus: selected,
        checked: item.checked ?? false,
        children: [item.icon, /*#__PURE__*/_jsx("span", {
          children: item.content ?? (isFilteredOptionItem(item) ? /*#__PURE__*/_jsx(ItemLabel, {
            label: item.label,
            start: item.highlightStart,
            end: item.highlightEnd
          }) : item.label)
        })]
      })
    })]
  });
}